export const OrderAvailability_Always = 'always';
export const OrderAvailability_Partial = 'partial';
/**
 * A missing `applyIdAffix` means the order receives the family id suffix.
 * Only an explicit `false` keeps that order's EHR id clean.
 */
export const OrderConfig_ApplyIdAffix_Default = true;
export const OrderConfigAvailabilities = [OrderAvailability_Always, OrderAvailability_Partial];
export const Order_AvailabilityLabelMap = {
    always: 'Always',
    partial: 'Partial'
};
export const Order_DaysOrder = [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
];
export const Order_DaysLabelMap = {
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tues',
    wed: 'Wed',
    thu: 'Thurs',
    fri: 'Fri',
    sat: 'Sat'
};
//# sourceMappingURL=consts.js.map